<app-loading *ngIf="contentReady"></app-loading>
<div class="invoice-container">
    <div class="invoice-header" style="margin-top: 50px;" *ngIf="!QrOption">

        <img src="/assets/fingerprint.png" alt="Company Logo">
        <h1>{{ 'fingerprint' | translate }} </h1>
        <div class="today-date">
            <span>تاريخ اليوم</span>
            <strong>{{ today | date:'yyyy-MM-dd' }}</strong>
        </div>
        <button class="btn btn-primary action-btn" *ngIf="canCheckIn"
            (click)="getLocationAndCheck(hasCheckedIn ? 'out' : 'in')" [disabled]="hasCheckedOut">
            {{ hasCheckedIn ? 'انهي العمل' : 'ابدء العمل' }}
        </button>
    </div>
    <div class="invoice-header" style="margin-top: 50px;" *ngIf="QrOption">
        <button class="btn btn-primary" (click)="generateQr()">
            {{ 'Create QR Code' | translate }}
        </button>

        <ul>
            <li *ngFor="let qr of qrList">
                <img [src]="fixImageUrl(qr.qr_url)" alt="QR Code">
                <br>
                <button class="btn btn-primary" (click)="downloadQr(fixImageUrl(qr.qr_url))">
                    {{ 'Download QR' | translate }}
                </button>
                <button class="btn btn-danger" (click)="deleteQr(qr.id)">
                    {{ 'Delete' | translate }}
                </button>
            </li>
        </ul>
    </div>

    <div class="invoice-header" style="margin-top: 50px;" *ngIf="scanMode">
        <zxing-scanner [formats]="allowedFormats" (scanSuccess)="onCodeResult($event)">
        </zxing-scanner>
    </div>




    <div class="row">
            @if(isAdmin){
        <div class="col-12 d-flex justify-content-left">
            <div *ngIf="hasaccess" class="dropdown filter" style="display: inline;">
                <button class="btn btn-secondary dropdown-toggle btn-primary first-btn" type="button"
                    data-bs-toggle="dropdown" style="width: 108px;" aria-expanded="false">{{ "Users" |
                    translate }} </button>
                <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">

                    <li><a class="dropdown-item" (click)="userFilter(el.id)"
                            *ngFor="let el of allUsers; let i = index">{{el.first_name}} {{el.last_name}} </a></li>
                </ul>
            </div>
        </div>
        }
        <div class="col-12">
            <h2>{{ "bymonth" | translate }}</h2>

            <div class="d-flex gap-2">
                <!-- اختيار السنة -->
                <select class="form-select" [(ngModel)]="selectedYear">
                    <option *ngFor="let year of years" [value]="year">{{ year }}</option>
                </select>

                <!-- اختيار الشهر -->
                <select class="form-select" [(ngModel)]="selectedMonth" (change)="loadAttendance()">
                    <option *ngFor="let month of months" [value]="month.value">{{isAr ? month.name_ar : month.name_en }}
                    </option>
                </select>
            </div>
        </div>

    </div>


    <div class="invoice-details row">

    </div>


    <!-- template -->
    @if(isAdmin){

    <div class="invoice-details row">


        <div class="col-sm-12 col-md-6">
            <table class="invoice-table">
                <tr>
                    <th>{{ "Date" | translate }}</th>
                    <th>ابدء العمل</th>
                    <th>انهي العمل</th>
                </tr>
                <tr *ngFor="let record of attendanceData">
                    <td>{{ record.date }}
                        <br>
                        <span> {{ 'workingtime' | translate }} : {{ calculateDiff(record.check_in_device_time,
                            record.check_out_device_time) }} </span>
                    </td>
                    <td>{{ record.check_in_device_time }} </td>
                    <td>{{ record.check_out_device_time || '-' }}</td>

                </tr>
            </table>
        </div>
        <div class="col-sm-12 col-md-6">
            <table class="invoice-table">
                <tr>
                    <th>{{ 'ip address' | translate }}</th>
                    <th>{{ 'fingerlocation' | translate }}</th>
                    <th>{{ 'server time' | translate }}</th>
                </tr>

                <tr *ngFor="let record of attendanceData">
                    <td>{{ record.ip_address || '-' }}
                        {{ extractDeviceInfo(record.device_info) || '-' }}
                    </td>
                    <td>
                        ابدء العمل
                        <a href="https://www.google.com/maps?q={{ record.check_in_latitude }},{{ record.check_in_longitude }}"
                            target="_blank">
                            {{ record.check_in_latitude || '-' }} , {{ record.check_in_longitude || '-' }}
                        </a>
                        <br />
                        انهي العمل
                        <a href="https://www.google.com/maps?q={{ record.check_out_latitude }},{{ record.check_out_longitude }}"
                            target="_blank">
                            {{ record.check_out_latitude || '-' }} , {{ record.check_out_longitude || '-' }}
                        </a><br>
                        <span
                            [ngClass]="{'text-success': record.location_access_denied == 0,'text-danger': record.location_access_denied == 1}">
                            @if(record.location_access_denied == 1){
                            {{ 'locationrejected' | translate }}

                            }
                            @else{

                            {{ 'access' | translate }}
                            }
                        </span>
                    </td>

                    <!-- ✅ server times -->
                    <td> ابدء العمل
                        {{ record.check_in_server_time || '-' }}
                        <br>
                        انهي العمل
                        {{ record.check_out_server_time || '-' }}
                    </td>


                </tr>
            </table>

        </div>
    </div>
    }
    @else{

    <table class="invoice-table">
        <tr>
            <th>{{ "Date" | translate }}</th>
            <th>ابدء العمل</th>
            <th>انهي العمل</th>
        </tr>
        <tr *ngFor="let record of attendanceData">
            <td>{{ record.date }}
                <br>
                <span>وقت الشغل انهارده : {{ calculateDiff(record.check_in_device_time, record.check_out_device_time) }}
                </span>

            </td>
            <td>{{ record.check_in_device_time || '-' }}</td>
            <td>{{ record.check_out_device_time || '-' }}</td>
        </tr>
    </table>
    }


</div>
